// Avoid hard-coding more than one place.
export const topNavHeight = 50; // Keep in sync w/ --header-height
